// import Button from 'monday-ui-react-core/dist/Button';
// import { useContext } from 'react';
// import { FileContext } from '../../../context/FileContext';
import SignDateControllers from './SignDateControllers';
// import LtrRtlSwitch from '../LtrRtlSwitch';

const TextControllers = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
}) => {
  // const { handleFontIncrease, handleFontDecrease } = useContext(FileContext);

  return (
    <>
      {/* <div className="font-size-editor">
        <Button
          kind={Button.kinds.SECONDARY}
          className="button left"
          onClick={handleFontDecrease}
        >
          -
        </Button>
        <span className="size-counter">{selectedItem?.fontSize || 11}</span>
        <Button
          kind={Button.kinds.SECONDARY}
          className="button right"
          onClick={handleFontIncrease}
        >
          +
        </Button>
      </div> */}
      {selectedItem?.type === 'date' ? (
        <>
          <SignDateControllers
            t={t}
            selectedItem={selectedItem}
            addedFormFields={addedFormFields}
            updateFormFields={updateFormFields}
          />
        </>
      ) : null}
      {/* <LtrRtlSwitch
        selectedItem={selectedItem}
        addedFormFields={addedFormFields}
        updateFormFields={updateFormFields}
      /> */}
    </>
  );
};

export default TextControllers;
